import React, { useState, useEffect, useRef } from 'react';
import './Experiencedetails.css';
//import axios from 'axios';
import Select from 'react-select';
import { useSearchParams, useLocation } from 'react-router-dom';
import { experienceSubmit, getDesignations, getEmployeeDetailsBasedonEmployeeUniqueeId } from '../../../../../../services/employeeCreationService';
import { getAuditLog } from '../../../../../../utils/calculateDaysInMonthUtils';
import ConfirmModal from "../../../../../../components/common/ConfirmModal/ConfirmModal";
import { selectStyleDisable, selectStyles } from "../../../../../../assets/Styles/selectStyle";
import { getFileName } from '../../../../../../utils/validations';

const ExperienceDetails = ({ formData, onChange, onNext, onPrevious }) => {
  const location = useLocation();
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isDirty, setIsDirty] = useState(false);

  const [completed, setCompleted] = useState(false);   // <-- NEW
  const isFieldDisabled = completed;

  const effectRan = useRef(false);
  const [experienceData, setExperienceData] = useState([
    {
      companyName: '',
      designationName:'',
      skillSet: '',
      fromDate: '',
      toDate: '',
      yearOfExperience: '',
      designation: '',
      uploadCertificate: null, // Relieving Letter
      appointmentLetter: null, // Appointment Letter
    },
  ]);
  const [personalInfo, setPersonalInfo] = useState({
    givenName: '',
    surname: '',
    jobPosition: '',
  });
  const [submitError, setSubmitError] = useState('');
  const [designations, setDesignations] = useState([]);
  const [focusState, setFocusState] = useState({});
  const [isFocused, setIsFocused] = useState({});
  const [errors, setErrors] = useState({});
  const [searchParams] = useSearchParams();
  const employeeUniqueId = searchParams.get('employeeUniqueId') || location.state?.applicationId;

  // Handle input changes
  const handleChange = (index, e) => {
    const { name, value } = e.target;
    const updatedData = [...experienceData];
    updatedData[index][name] = value;
    setExperienceData(updatedData);
    setIsDirty(true);
  };

  // Handle designation select change
  const handleSelectChange = (index, selectedOption) => {
    const updatedData = [...experienceData];
    updatedData[index].designation = selectedOption ? selectedOption.value : '';
    setExperienceData(updatedData);
    setIsDirty(true);
  };

  // Calculate experience in years
  const calculateYearOfExperience = (index) => {
    const fromDate = new Date(experienceData[index].fromDate);
    const toDate = new Date(experienceData[index].toDate);
    if (fromDate && toDate && toDate >= fromDate) {
      const diffInTime = toDate.getTime() - fromDate.getTime();
      const diffInYears = diffInTime / (1000 * 3600 * 24 * 365);
      const updatedData = [...experienceData];
      updatedData[index].yearOfExperience = diffInYears.toFixed(1);
      setExperienceData(updatedData);
    }
  };

  // Add new row
  const handleAddToTable = () => {
    const newData = [
      ...experienceData,
      {
        companyName: '',
        designationName:'',
        skillSet: '',
        fromDate: '',
        toDate: '',
        yearOfExperience: '',
        designation: '',
        uploadCertificate: null,
        appointmentLetter: null,
      },
    ];
    setExperienceData(newData);
  };


  // 🧩 File Upload Handler
// const handleFileChange = (e, field, index) => {
//   const file = e.target.files[0];
//   if (!file) return;

//   // Update experienceData (for UI preview)
//   const updated = [...experienceData];
//   updated[index][field] = { name: file.name, size: file.size, type: file.type };
//   setExperienceData(updated);

//   // Track uploaded files for submission
//   setUploadedFiles((prev) => {
//     // Remove any existing file for same field/index before adding new one
//     const filtered = prev.filter((f) => !(f.field === field && f.index === index));
//     return [...filtered, { file, field, index }];
//   });

//   setIsDirty(true);
// };

const handleFileChange = (e, field, index) => {
  const file = e.target.files[0];
  if (!file) return;

  const updated = [...experienceData];
  updated[index][field] = { name: file.name };
  setExperienceData(updated);

  setUploadedFiles((prev) => {
    const filtered = prev.filter(f => !(f.field === field && f.index === index));
    return [...filtered, { file, field, index }];
  });

  setIsDirty(true);
};

  // Fetch designations
  
//   const handleSubmit = async () => {
//   try {
//     const fullName = localStorage.getItem("full_name");
//     const role = localStorage.getItem("role");
//     const employeeId = localStorage.getItem("employeeId");

//     // Build experience payload (without files)
//     const experienceList = experienceData.map((exp) => ({
//       id: exp.id || undefined,
//       companyName: exp.companyName || "",
//       designation: exp.designation ? { id: Number(exp.designation) } : null,
//       designationName: exp.designationName || "",
//       skillSet: exp.skillSet || "",
//       fromDate: exp.fromDate || "",
//       toDate: exp.toDate || "",
//       salaryDrawn: Number(exp.salaryDrawn) || 0,
//     }));

//     // Create final payload
//     const payload = { experienceList };

//     if (employeeId && role) {
//       payload.auditLog = { name: fullName || "", role, employeeId };
//     }

//     console.log("✅ JSON payload:", JSON.stringify(payload, null, 2));

//     // Prepare FormData
//     const formDataObj = new FormData();
//     formDataObj.append("request", JSON.stringify(payload));

//     // Append all uploaded files under the same key "files" (to match Postman)
//     uploadedFiles.forEach(({ file }) => {
//       console.log("📎 Appending file:", file.name);
//       formDataObj.append("files", file);
//     });

//     // Debug: log all formData keys and values
//     for (const [key, value] of formDataObj.entries()) {
//       console.log(`${key}:`, value instanceof File ? value.name : value);
//     }

//     // API call
//     const response = await experienceSubmit(employeeUniqueId, formDataObj);
//     console.log("✅ Response received:", response.data);

//     // Update local state with response
//     setExperienceData(
//       response.data.map((exp) => ({
//         id: exp.id || "",
//         companyName: exp.companyName || "",
//         designationName: exp.designationName || "",
//         designation: exp.designation?.id || "",
//         skillSet: exp.skillSet || "",
//         fromDate: exp.fromDate || "",
//         toDate: exp.toDate || "",
//         salaryDrawn: exp.salaryDrawn || 0,
//         uploadCertificate: exp.relievingLetter
//           ? { name: exp.relievingLetter.split("/").pop() }
//           : null,
//         appointmentLetter: exp.appointmentLetter
//           ? { name: exp.appointmentLetter.split("/").pop() }
//           : null,
//       }))
//     );

//     // Reset
//     setUploadedFiles([]);
//     setIsDirty(false);
//     onNext();

//   } catch (err) {
//     console.error("❌ Error saving experience:", err.response?.data || err);
//     setSubmitError("Failed to save experience details");
//   }
// };

const handleSubmit = async () => {
  try {
    const experienceList = experienceData.map((exp) => ({
      id: exp.id || undefined,
      companyName: exp.companyName || "",
      designation: exp.designation ? { id: Number(exp.designation) } : null,
      designationName: exp.designationName || "",
      skillSet: exp.skillSet || "",
      fromDate: exp.fromDate || "",
      toDate: exp.toDate || "",
      salaryDrawn: Number(exp.salaryDrawn) || 0,
    }));

    const payload = { experienceList };
    const fullName = localStorage.getItem("full_name");
    const role = localStorage.getItem("role");
    const employeeId = localStorage.getItem("employeeId");
    if (employeeId && role) {
      payload.auditLog = { name: fullName || "", role, employeeId };
    }

    const formDataObj = new FormData();
    formDataObj.append("request", JSON.stringify(payload));

    // ORDERED FILES: 2 per row
    const totalSlots = experienceData.length * 2;
    const orderedFiles = new Array(totalSlots).fill(null);

    uploadedFiles.forEach(({ file, field, index }) => {
      const baseIndex = index * 2;
      if (field === "appointmentLetter") {
        orderedFiles[baseIndex] = file;
      } else if (field === "uploadCertificate") {
        orderedFiles[baseIndex + 1] = file;
      }
    });

    // Append ALL files (including empty placeholders)
    orderedFiles.forEach(file => {
      if (file) {
        formDataObj.append("files", file);
      } else {
        formDataObj.append("files", new Blob([], { type: "application/octet-stream" }), "");
      }
    });

    // Debug
    for (const [k, v] of formDataObj.entries()) {
      console.log(k, v instanceof File ? v.name : "(empty)");
    }

    const response = await experienceSubmit(employeeUniqueId, formDataObj);

    setExperienceData(
      response.data.map((exp, i) => ({
        ...experienceData[i],
        id: exp.id,
        appointmentLetter: exp.appointmentLetter
          ? { name: exp.appointmentLetter.split("/").pop() }
          : experienceData[i].appointmentLetter,
        uploadCertificate: exp.relievingLetter
          ? { name: exp.relievingLetter.split("/").pop() }
          : experienceData[i].uploadCertificate,
      }))
    );

    setUploadedFiles([]);
    setIsDirty(false);
    onNext();

  } catch (err) {
    console.error("Save failed:", err);
  }
};

  useEffect(() => {
    const fetchDesignations = async () => {
      try {
        // const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/designations`);
        // const data = await response.json();

        const data = await getDesignations();
        // setDesignations(data.map((item) => ({ value: item.id, label: item.designationName })));
      } catch (error) {
        console.error('Error fetching designations:', error);
      }
    };
    if (!effectRan.current) {
      fetchDesignations();
    }
    return () => {
      effectRan.current = true;
    }


  }, []);

  // Fetch application details
  useEffect(() => {
    const fetchApplicationDetails = async () => {
      if (!employeeUniqueId) return;

      try {
        // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/personal-info/${employeeUniqueId}`);
        // const appData = response.data;
        const appData = await getEmployeeDetailsBasedonEmployeeUniqueeId(employeeUniqueId);
        if (appData.experiences && appData.experiences.length > 0) {
          setExperienceData(
            appData.experiences.map((exp) => ({
              id: exp.id || '',
              companyName: exp.companyName || '',
              designationName:exp.designationName||'',
              designation: exp.designation?.id || '',
              skillSet: exp.skillSet || '',
              fromDate: exp.fromDate || '',
              toDate: exp.toDate || '',
              salaryDrawn: exp.salaryDrawn || 0,
              uploadCertificate: exp.relievingLetter ? { name: exp.relievingLetter.split('/').pop() } : null,
              appointmentLetter: exp.appointmentLetter ? { name: exp.appointmentLetter.split('/').pop() } : null,
              verified: exp.verified,
            }))
          );
        } else {
          setExperienceData([
            {
              companyName: '',
              designationName:'',
              skillSet: '',
              fromDate: '',
              toDate: '',
              yearOfExperience: '',
              designation: '',
              uploadCertificate: null,
              appointmentLetter: null,
            },
          ]);
        }

        setPersonalInfo({
          givenName: appData.givenName || appData.employee?.firstName || '',
          surname: appData.surname || appData.employee?.lastName || '',
          jobPosition: appData.employee?.jobPosition || '',
        });
        setCompleted(appData.completed === true);
        console.log('Fetched application data:', appData);
        setIsDirty(false);
      } catch (error) {
        console.error('Error fetching application data:', error);
      }
    };

    if (!effectRan.current) {
      fetchApplicationDetails();
    }
    return () => {
      effectRan.current = true;
    }

  }, [employeeUniqueId]);

  // Handle previous click with confirmation modal
  const handlePreviousClick = () => {
    const isFormDirty = experienceData.some(
      (entry) =>
        entry.companyName ||
      entry.designationName||
        entry.designation ||
        entry.skillSet ||
        entry.fromDate ||
        entry.toDate ||
        entry.uploadCertificate ||
        entry.appointmentLetter
    );
    if (isFormDirty && isDirty) {
      setShowConfirmModal(true);
    } else {
      onPrevious();
    }
  };

  const handleConfirmYes = () => {
    setExperienceData([
      {
        companyName: '',
        designationName:'',
        skillSet: '',
        fromDate: '',
        toDate: '',
        yearOfExperience: '',
        designation: '',
        uploadCertificate: null,
        appointmentLetter: null,
      },
    ]);
    setUploadedFiles([]);
    setShowConfirmModal(false);
    setIsDirty(false);
    onPrevious();
  };

  const handleConfirmNo = () => {
    setShowConfirmModal(false);
  };

 const handleRemoveForm = async (idToRemove) => {
  try {
    // Call DELETE API
    await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/experience/${idToRemove}`, {
      method: "DELETE",
    });

    // Update state after successful deletion
    setExperienceData((prevData) =>
      prevData.filter((exp) => exp.id !== idToRemove)
    );

    console.log(`Experience ${idToRemove} deleted successfully.`);
  } catch (error) {
    console.error("Failed to delete experience:", error);
    alert("Could not delete the experience. Please try again.");
  }
};


  return (
    <React.Fragment>
      <div className="experiencedetails-container">
        <div className="experiencedetails-box">
          <div className="expdetails-heading">
            <span className="highlight-label">Temporary ID: </span>
            {employeeUniqueId} - {personalInfo.givenName} {personalInfo.surname} -{' '}
            {personalInfo.jobPosition?.designationName || ''}
          </div>

          <h2 className="experiencedetails-heading">Experience Details</h2>
          {experienceData.map((form, index) => (
            <div key={index} className="experiencedetails-form">
              <div className={`experiencedetails-floating-label-container ${form.companyName || focusState.companyName ? 'float-label' : ''}`}>
                <label>Company Name</label>
                <input
                  type="text"
                  name="companyName"
                  value={form.companyName}
                  onChange={(e) => handleChange(index, e)}
                  onFocus={() => setFocusState((f) => ({ ...f, companyName: true }))}
                  onBlur={() => setFocusState((f) => ({ ...f, companyName: false }))}
                 // disabled={isFieldDisabled}
                />
                {errors.companyName && <span className="error-message">{errors.companyName}</span>}
              </div>
              <div className={`experiencedetails-floating-label-container ${form.designationName || isFocused.designationName ? 'float-label' : ''}`}> 

                <label>Designation</label>
                <input type="text"
                  name="designationName"
                  value={form.designationName}
                  onChange={(e) => handleChange(index, e)}
                  onFocus={() => setFocusState((f) => ({ ...f, designationName: true }))}
                  onBlur={() => setFocusState((f) => ({ ...f, designationName: false }))}
                 // disabled={isFieldDisabled}

                />

              </div>
              
              {/* <div className={`experiencedetails-floating-label-container ${form.designation || isFocused.designation ? 'float-label' : ''}`}>
                <Select
                  name="designation"
                  options={designations}
                  value={designations.find((opt) => opt.value === form.designation) || null}
                  onChange={(selectedOption) => handleSelectChange(index, selectedOption)}
                  placeholder=""
                  onFocus={() => setIsFocused((f) => ({ ...f, designation: true }))}
                  onBlur={() => setIsFocused((f) => ({ ...f, designation: false }))}
                  isClearable
                  isDisabled={isFieldDisabled}
                  styles={isFieldDisabled ? selectStyleDisable : selectStyles}
                />
                <label>Designation</label>
                {errors.designation && <span className="error-message">{errors.designation}</span>}
              </div> */}
              <div
                className={`experiencedetails-floating-label-container ${form.skillSet || focusState.skillSet ? 'float-label' : ''
                  }`}
              >
                <label>Skill Set</label>
                <input
                  type="text"
                  name="skillSet"
                  value={form.skillSet}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[a-zA-Z\s,]*$/.test(value)) {
                      handleChange(index, e);
                    }
                  }}
                  placeholder=""
                  onFocus={() => setFocusState((f) => ({ ...f, skillSet: true }))}
                  onBlur={() => setFocusState((f) => ({ ...f, skillSet: false }))}
                 // disabled={isFieldDisabled}
                />
                {errors.skillSet && <span className="error-message">{errors.skillSet}</span>}
              </div>
              <div
                className={`experiencedetails-floating-label-container ${form.fromDate || focusState.fromDate ? 'float-label' : ''
                  }`}
              >
                <label>From Date (dd-mm-yyyy)</label>
                <input
                  type="date"
                  name="fromDate"
                  value={form.fromDate}
                  onChange={(e) => {
                    handleChange(index, e);
                    calculateYearOfExperience(index);
                  }}
                  placeholder=""
                  onFocus={() => setFocusState((f) => ({ ...f, fromDate: true }))}
                  onBlur={() => setFocusState((f) => ({ ...f, fromDate: false }))}
                 // disabled={isFieldDisabled}
                />
                {errors.fromDate && <span className="error-message">{errors.fromDate}</span>}
              </div>
              <div
                className={`experiencedetails-floating-label-container ${form.toDate || focusState.toDate ? 'float-label' : ''
                  }`}
              >
                <label>To Date (dd-mm-yyyy)</label>
                <input
                  type="date"
                  name="toDate"
                  value={form.toDate}
                  onChange={(e) => {
                    handleChange(index, e);
                    calculateYearOfExperience(index);
                  }}
                  placeholder=""
                  onFocus={() => setFocusState((f) => ({ ...f, toDate: true }))}
                  onBlur={() => setFocusState((f) => ({ ...f, toDate: false }))}
                 // disabled={isFieldDisabled}
                />
                {errors.toDate && <span className="error-message">{errors.toDate}</span>}
              </div>
              <div
                className={`experiencedetails-floating-label-container ${form.salaryDrawn || focusState.salaryDrawn ? 'float-label' : ''
                  }`}
              >
                <label>CTC</label>
                <input
                  type="text"
                  name="salaryDrawn"
                  value={form.salaryDrawn}
                  onChange={(e) => handleChange(index, e)}
                  onFocus={() => setFocusState((f) => ({ ...f, salaryDrawn: true }))}
                  onBlur={() => setFocusState((f) => ({ ...f, salaryDrawn: false }))}
                 // disabled={isFieldDisabled}
                />
                {errors.salaryDrawn && <span className="error-message">{errors.salaryDrawn}</span>}
              </div>
              <div className="eductiondetails-input-containers">
                <label>Appointment Letter</label>
                {(() => {
                  const isAppCompleted = isFieldDisabled;

                  // Condition 2: The current certificate has been explicitly verified (true)
                  const isCertificateVerified = form.verified === true;

                  // Disable the input ONLY if the app is completed AND the certificate is verified.
                  // If the app is completed but the certificate is NOT verified (false or null), 
                  // the input must remain enabled for the user to upload a correction.
                  const disableFileInput = isAppCompleted && isCertificateVerified;
                  return (
                    <input
                      type="file"
                      name="appointmentLetter"
                      onChange={(e) => handleFileChange(e, 'appointmentLetter', index)}
                      accept=".pdf,.jpg,.jpeg,.png"
                      //disabled={disableFileInput}
                    />
                  )

                })()}
                {/* <input
                  type="file"
                  name="appointmentLetter"
                  onChange={(e) => handleFileChange(e, 'appointmentLetter', index)}
                  accept=".pdf,.jpg,.jpeg,.png"
                  disabled={isFieldDisabled}
                /> */}
                {form.appointmentLetter && (
                  <span className="file-name">
                    {/* {form.appointmentLetter.name.split('/').pop().split('*').pop() || form.appointmentLetter.name} */}
                    {getFileName(form.appointmentLetter.name)}
                  </span>
                )}
              </div>
              <div className="eductiondetails-input-containers">
                <label>Relieving / Experience Letter</label>
                {(() => {
                  const isAppCompleted = isFieldDisabled;

                  // Condition 2: The current certificate has been explicitly verified (true)
                  const isCertificateVerified = form.verified === true;

                  // Disable the input ONLY if the app is completed AND the certificate is verified.
                  // If the app is completed but the certificate is NOT verified (false or null), 
                  // the input must remain enabled for the user to upload a correction.
                  const disableFileInput = isAppCompleted && isCertificateVerified;
                  return (
                    <input
                      type="file"
                      name="uploadCertificate"
                      onChange={(e) => handleFileChange(e, 'uploadCertificate', index)}
                      accept=".pdf,.jpg,.jpeg,.png"
                     // disabled={disableFileInput}
                    />
                  )

                })()}

                {form.uploadCertificate && (
                  <span className="file-name">
                    {/* {form.uploadCertificate.name.split('/').pop().split('*').pop() || form.uploadCertificate.name} */}
                    {getFileName(form.uploadCertificate.name)}
                  </span>
                )}
              </div>
              {/* <button
                type="button"
                className="experiencedetails-table-btn"
                onClick={handleAddToTable}
                disabled={
                  !(
                    experienceData[index].companyName &&
                    experienceData[index].skillSet &&
                    experienceData[index].fromDate &&
                    experienceData[index].designation
                  )
                }
              >
                +
              </button> */}

              <div className="experiencedetails-input-containers">
                {/* Show "+" button only for the last form */}
                {index === experienceData.length - 1 && (
                  <button
                    type="button"
                    className="experiencedetails-table-btn"
                    onClick={handleAddToTable}
                    disabled={
                      !(
                        experienceData[index].companyName &&
                        experienceData[index].skillSet &&
                        experienceData[index].fromDate &&
                        experienceData[index].designationName
                        // &&
                        // !isFieldDisabled
                        
                      )
                      
                    }
                  >
                    +
                  </button>
                )}

                {/* Show "–" for all forms except the first */}
                {experienceData.length > 0 && (
                  <button
                    type="button"
                    className="experiencedetails-table-btn remove-btn"
                    onClick={() => handleRemoveForm(form.id)} 
                  >
                    –
                  </button>
                )}
              </div>


            </div>
          ))}
          <div className="experiencedetails-btns-div">
            <button type="button" className="experiencedetails-btn" onClick={handlePreviousClick}>
              Previous
            </button>
            <button type="button" className="experiencedetails-btn-next" onClick={handleSubmit}>
              Save & Next
            </button>
          </div>
        </div>
        {/* {showConfirmModal && (
          <div className="modal-overlay">
            <div className="custom-modal">
              <p>Do you want to clear the form?</p>
              <div className="modal-buttons">
                <button type="button" onClick={handleConfirmYes}>Yes</button>
                <button type="button" onClick={handleConfirmNo}>No</button>
              </div>
            </div>
          </div>
        )} */}

        {showConfirmModal && (
          <ConfirmModal
            message="Do you want to clear the form?"
            onConfirm={handleConfirmYes}
            onCancel={handleConfirmNo}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default ExperienceDetails;